












import { Vue, Component } from 'vue-property-decorator'
import UserHeader from '@/components/common/layout/UserHeader.vue'
import AppFooter from '@/components/footer/AppFooter.vue'

@Component({
  name: 'Layout',
  components: {
    UserHeader,
    AppFooter
  }
})
export default class Layout extends Vue {}
